import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { freeTrialVerifyEmailCacheKeys } from "./constants";
import type { VerifyEmailPayload } from "./types";

export const verifyEmail = reactQueryMutationAdapter(
  freeTrialVerifyEmailCacheKeys,
  async (payload: VerifyEmailPayload): Promise<any> => {
    return fetch(`/free_trial/verify_email`, "POST", payload, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
